import DoctorHome from "./home";

export default DoctorHome;
